import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IProduct } from '../../models/products.models';
import { TranslateService } from '@ngx-translate/core';
import { customValidator } from 'src/app/shared/validators/fields-validators';
import { FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-details-setting-dialog-edits',
  templateUrl: './details-setting-dialog-edits.component.html',
  styleUrls: ['./details-setting-dialog-edits.component.scss']
})
export class DetailsSettingDialogEditsComponent implements OnInit {
  form!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DetailsSettingDialogEditsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      max_qte: [this.data?.max_qte ?? null],
      min_qte: [this.data?.min_qte ?? null],
      increment: [this.data?.increment ?? null],
      reorder_point: [this.data?.reorder_point ?? null],
    }, {
      validators: customValidator(this.data.translate)
    });
  }

  sanitize(event: any) {
    event.target.value = event.target.value.replace(/[^\d]/g, '');
  }

  save(): boolean | void {
    if(this.form.invalid){
      this.form.markAllAsTouched()
      return false
    }
    this.dialogRef.close(this.form.value)
  }

  cancel() {
    this.dialogRef.close();
  }
}
